<template>
  <div id="AppSelectProduct" style="height:350px;">
    <!-- 消耗品選択 -->
    <div class="columns is-vcentered">
      <!-- 消耗品選択 -->
      <div class="column" style>
        <b-input v-model="productCode" name="productCode" type="text" placeholder="検索条件を入力してください"></b-input>
      </div>
      <div>
        <b-button
          class="button"
          type="is-primary"
          icon-left="keyboard-backspace"
          native-type="button"
          @click="filteredDeliveryList(productCode)"
        >検索</b-button>
      </div>
      <div class="control column" style="min-height:350px;">
        <b-table
          :data="filteredProduct"
          :selected.sync="selectedProduct"
          focusable
          class="tableStyle"
        >
          <template slot-scope="props">
            <b-table-column field="officeCode">
              {{ props.row.key }}
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppSelectProduct",
  props: ["deliveryKindFlag", "productMasterflg"],
  methods: {
    getProduct: function() {
      return this.selectedProduct.productCode;
    },
    back: function(event) {},
    filteredDeliveryList: function(productCode) {
      if (productCode == "") {
        this.$dialog.alert({
          title: "　",
          message: "検索条件を指定してください。"
        });
      } else {
        this.filteredProduct = this.productMaster.filter(option => {
          var retValue =
            option.key
              .toString()
              .toLowerCase()
              .indexOf(productCode.toLowerCase()) >= 0;
          return retValue;
        });
        if (this.filteredProduct.length == 0) {
          this.$dialog.alert({
            title: "　",
            message: "検索条件に当てはまる消耗品はありません。"
          });
        }
      }
    }
  },
  data() {
    var productMaster = [];
    var productMasterflg = this.$props.productMasterflg
      ? this.$props.productMasterflg
      : false;

    if (!productMasterflg) {
      if (this.$props.deliveryKindFlag == 1) {
        this.getDeliveryList(productMaster);
      } else {
        this.getProductList(productMaster);
      }
    } else {
      this.getProductList(productMaster);
    }

    return {
      productMaster,
      productCode: "",
      filteredProduct: [],
      selectedProduct: {},
    };
  },
  mounted: function() {}
};
</script>
<style lang="scss" scoped>
  .tableStyle {
    border:solid 1px;
    border-color:lightgrey;
    width: 430px;
    height:300px;
    overflow-y:scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppSelectProduct.vue